export default __webpack_public_path__ + "static/media/6h.d14b3f76.svg";